import { Pipe, PipeTransform } from '@angular/core';
import { isTimestamp } from '../services/is-timestamp.util';

@Pipe({
  name: 'fileDisplayName',
  standalone: false,
})
export class FileDisplayNamePipe implements PipeTransform {
  transform(originalName: string, isExtensionless: boolean = false): string {
    if (!originalName) {
      return '';
    }

    const extensionParts = originalName.split('.');
    const extension = extensionParts.length > 1 ? extensionParts.pop() : '';
    const nameParts = extensionParts.join('.').split('_');
    const isTime = isTimestamp(nameParts[nameParts.length - 1]);
    if (isTime) {
      nameParts.pop();
    }
    return nameParts.join('_') + (isExtensionless ? '' : extension ? '.' + extension : '');
  }
}
